module.exports = __webpack_public_path__ + "static/side-img-3-7775508b70116b5d827b74aed310c7a2.png";